<template>
  <div id="repositories">
    <el-button
      class="action"
      size="small"
      type="primary"
      @click="connect = true"
    >
      Connect a Git repository
    </el-button>

    <el-divider content-position="left">
      <h3>Connected Repositories</h3>
    </el-divider>

    <div v-loading="loading">
      <div v-if="data.length === 0" class="align-center nothing">
        <p>Build and deploy your application from your code</p>
        <p>Connect a repository now to benefit from the simplified deployment solution</p>

        <template v-if="repositories.length === 0">
          <h4>You don't have a git repository yet?</h4>
          <el-button
            type="primary"
            size="small"
            @click="create = true"
          >
            Install a Git repository on this instance
          </el-button>
        </template>
      </div>

      <BuildCard
        v-for="repository in data"
        :key="repository.id"
        :repository="repository"
        :application-id="application.id"
        @change="load"
      />

      <BuildCreate
        :instance="instance"
        :application-id="application.id"
        :open.sync="create"
        @change="load"
      />

      <BuildConnect
        :instance="instance"
        :application-id="application.id"
        :connect-type="connectType"
        :open.sync="connect"
        @change="load"
      />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import BuildCard from '../Build/Card'
import BuildCreate from '../Build/Create'
import BuildConnect from '../Build/Connect'

export default {
  props: {
    instance: Object,
    application: Object
  },
  components: {
    BuildCard,
    BuildCreate,
    BuildConnect
  },
  data () {
    return {
      loading: false,
      create: false,
      connect: false,
      connectType: null,
      data: []
    }
  },
  created () {
    this.load()

    if (this.$route.query.connect) {
      this.connect = true
      this.connectType = this.$route.query.connect
    }
  },
  computed: mapState(['repositories']),
  methods: {
    load () {
      if (this.loading) {
        return
      }

      this.loading = true
      this.$store.dispatch('getApplicationRepositories', this.application).then((repositories) => {
        this.data = this.repositories.filter((repository) => repositories.find((r) => r.id === repository.id))
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    }
  },
  watch: {
    application () {
      this.$nextTick(() => this.load())
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../../theme";

  .nothing {
    background: url(../../assets/logo-github.png) no-repeat top center;
    background-size: 80px;
    padding-top: 100px;
    margin-top: 50px;

    h4 {
      margin-top: 50px;
    }
  }
</style>
